import React from 'react';
import {BigButtonTool} from "../../oneLineToolSpace";
import picIcon from "../../../components/image/menupictures.png";
import BaseComponent from "../../../../../base/BaseComponent";
import PhotoUpload from "../../../components/photoUpload/PhotoUpload";
import {uuid,permissionCheck} from "../../../../../utils";
import MedialSelect from "../components/medialSelect";
import localUpload from "../components/img/localUpload.png";
import resourceSelect from "../components/img/resourceSelect.png";
import taskPic from "../../../../editor/components/image/taskPic.png";
import address from "../components/img/address.png";
import PictureAmend from "../../../components/toolbarAmendModal/pictureAmend";
import CurrencyResourceDialog from "../../../../resource/view/dialog/CurrencyResourceDialog";
import InterviewTaskPicture from "../../../components/pluginsSpace/taskPicture/taskPicture";
import {BaseHandler} from "../../../../../base/ws";
import $ from "jquery";
import {systemWebsocket} from "../../../../../base/auth";
import {message} from "antd"


const sysConfigGetValueByKey = (key, defaultValue = '') =>{
    return window.sysConfig && window.sysConfig.getValueByKey(key, defaultValue) || defaultValue
};
export const buildInsertPicHtml = ({url:url, width,height,vspace:vspace,title:title,sourceUrl="",name="",float,border=0,isWrapperP=true})=>{//isWrapperP是否默认用P标签包裹
    if(!width){
        width = sysConfigGetValueByKey("editor.content.pic.insert.width", "500");
    }
    if(float === "center"){//单独成行
        let img = `<img src="${url}" source-url="${sourceUrl}" 
          width="${width}" name="${name}" height="${height?height:'auto'}" title="${title?title:''}" border="${border?border:''}" 
          vspace="${vspace?vspace:''}" alias-label="img" />`;
        if(isWrapperP){
            return `<p style="text-align: center">${img}</p>`
        }
        return img;
    }
    let img = `<img src="${url}" source-url="${sourceUrl}" style="${float?"float:"+float:""}"
          width="${width}" name="${name}" height="${height?height:'auto'}" title="${title?title:''}" border="${border?border:''}" 
          vspace="${vspace?vspace:''}" alias-label="img" />`;
    if(isWrapperP){
        return `<p>${img}</p>`
    }
    return img;
};
window.editorBuildInsertPicHtml = buildInsertPicHtml;

class PictureTool extends BaseComponent {

    state = {
        dialog: false,
        dialogKey: uuid(),
        isHover: "none",
        modalKey: uuid(),
        taskKey:uuid(),
        resourceSelectKey: uuid(),
        closeKey:uuid(),
    };

    photoUploadOk = (fileList) => {
        console.log("fileList:  ", fileList);
        let imgHTML = '';
        fileList && fileList.map(file => {
            if(file.response){
                imgHTML += buildInsertPicHtml({
                    ...file.response,
                    url: file.cssWater?file.response.waterPath:file.response.smallPath,
                    sourceUrl:file.response.path,
                    float:file.float,
                    title:file.name,
                    name:file.name,
                    border: file.cssBorder ? parseInt(file.cssBorder) : null,
                    vspace: file.cssMargin ? parseInt(file.cssMargin) : null,
                    width: file.cssWidth ? parseInt(file.cssWidth) : null,
                    height: file.cssHeight ? parseInt(file.cssHeight) : null
                });
            }
        });
        let isSuccess = true;
        if(imgHTML){
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", imgHTML);
        }
        if(isSuccess) {
            this.photoUploadHandleCancel();
        }
    };

    insertPictureToContent(fileList,call){
        let imgHTML = '';
        fileList && fileList.map(file => {
            imgHTML += buildInsertPicHtml({
                ...file,
                url: file.smallPath?file.smallPath:file.icon,sourceUrl:file.path,
                width: file.cssWidth ? parseInt(file.cssWidth) : 0,
                height: file.cssHeight ? parseInt(file.cssHeight) : null
            });
        });
        let isSuccess = true;
        if(imgHTML){
           isSuccess = this.props.editor.rmtExecCommand("inserthtml", imgHTML);
        }
        call&&call(isSuccess)
    }

    photoUploadHandleCancel = () => {
        this.setState({
            dialog: false,
            dialogKey: uuid()
        });
    };

    render() {
        return (
            <>
                <div style={{position:'relative'}}
                     onMouseEnter={() => {this.setState({isHover: "block"})}}
                     onMouseLeave={() => this.setState({isHover: "none"})}
                     onClick={()=>{this.setState({isHover: "none"})}}
                >
                    <BigButtonTool src={picIcon} text={"图片"} height={this.props.height} width={this.props.width}
                                   onClick={()=>{
                                       this.setState({dialog:true})
                                   }}
                    />
                    {/*图片下拉框*/}
                    <div style={{
                        position: 'absolute',
                        top: '58px',
                        left: "10px",
                        zIndex: 999,
                        display: this.state.isHover
                    }}>
                        <MedialSelect >
                            <div className={'selectList'}
                                 onClick={()=>{
                                     this.setState({dialog:true})
                                 }}
                                 style={{width:'119px',height:'32px',padding:'0 10px',lineHeight:"32px"}}>
                                <img src={localUpload} style={{marginRight:"8px"}}/>
                                <span>本地上传</span>
                            </div>
                            {permissionCheck('right_to_use_zyk')? <div className={'selectList'} onClick={()=>this.resourceDialog.show()} style={{width:'119px',height:'32px',padding:'0 10px',lineHeight:"32px"}}>
                                <img src={resourceSelect} style={{marginRight:"8px"}}/>
                                <span>资源库选择</span>
                            </div>:null}

                            <div className={'selectList'} style={{width:'119px',height:'32px',padding:'0 10px',lineHeight:"32px"}}
                                 onClick={()=>{
                                     this.PictureAmend.showModal()
                                 }}>
                                <img src={address} style={{marginRight:"8px"}}/>
                                <span>地址插入</span>
                            </div>
                            {
                                this.urlParams?.taskId?(
                                    <div className={'selectList'}
                                         style={{width: '119px', height: '32px', padding: '0 10px', lineHeight: "32px"}}
                                         onClick={() => {
                                             this.TaskPicture.showModal()
                                         }}>
                                        <img src={taskPic} style={{marginRight: "8px"}}/>
                                        <span>任务图片</span>
                                    </div>
                                ):""
                            }
                        </MedialSelect>
                    </div>
                </div>
                <PhotoUpload key={this.state.dialogKey} photoUpload={this.state.dialog} handleOk={(fileList)=>this.photoUploadOk(fileList)}
                             handleCancel={() => this.photoUploadHandleCancel()}/>
                <CurrencyResourceDialog
                    onOk={(checkedData)=>{
                        this.insertPictureToContent(checkedData);
                    }}
                    ref={resourceDialog=>this.resourceDialog = resourceDialog}
                    key={this.state.closeKey}
                    onCallBackOk={(checkedData,call)=>{
                        this.checkFileType(checkedData,(newFiles)=>{
                            this.insertPictureToContent(newFiles,call);
                        },call);
                    }}
                    onCloseCall={()=>{this.setState({closeKey:uuid()})}}
                />
                <PictureAmend key={this.state.modalKey} ref={(e)=>this.PictureAmend=e} title={"插入图片"} editor={this.props.editor}
                              onCloseCall={()=>{this.setState({modalKey:uuid()})}}/>
                <InterviewTaskPicture key={this.state.taskKey} ref={(e)=>this.TaskPicture=e} title={"任务图片"} editor={this.props.editor}
                             onCloseCall={()=>{this.setState({taskKey:uuid()})}}
                />

            </>
        );
    }
    newPicType=['jpg','jpeg', 'gif', 'png', 'bmp'];
    newPicTypes = [...this.newPicType,...this.newPicType.toUpperCase()];
    checkFileType = (files,checkCall,closeCall) => {
        if(!files?.length) {
            // message.destroy();
            // message.warning("请先选择一个资源");
            closeCall&&closeCall(true);
            return false
        }
        let newFiles = files;
        let checkResult = files.every(file=>this.newPicTypes.indexOf(file.suffix)>-1);
        if(!checkResult) {
            message.destroy();
            message.error(`目前只支持以下格式：${this.newPicType.join("，")}`);
            return false
        }
        checkCall&&checkCall(newFiles)
    }
}

export class EditorOriginPictureUploadHandler extends BaseHandler{//编辑器外站图片复制到编辑器中后自动上传，通过ws监听上传后的结果

    constructor(){
        super();
    }

    origin;
    data;

    order() {
        return BaseHandler.ORDER_HIGHT - 2;
    }

    isSupport(msg){
        try {
            let {origin, result:{data}} = JSON.parse(msg);
            if(origin){
                this.origin = origin;
                this.data = data;
                return true;
            }
            return false;
        }catch (e) {
            // console.error(e);
            return false;
        }
    }

    handle(msg){
        let that = this;
        $(window.ueditor.document).find(`[src="${this.origin}"]`).each(function(){
            $(this).after(buildInsertPicHtml({url:that.data.smallPath, sourceUrl:that.data.path, title:that.data.name, name:that.data.name,isWrapperP:false}));
            $(this).remove();
        })
    }

}

export class EditorOriginPictureUploadOverHandler extends BaseHandler{//编辑器外站图片复制到编辑器中后自动上传，通过ws监听是否全部上传完成

    constructor(){
        super();
    }

    order() {
        return BaseHandler.ORDER_HIGHT - 3;
    }

    isSupport(msg){
        try {
            let {getByExternalUrl} = JSON.parse(msg);
            return getByExternalUrl === "ok";
        }catch (e) {
            // console.error(e);
            return false;
        }
    }

    handle(msg){
        window.loading.hide();
    }
}

systemWebsocket.addHandler(new EditorOriginPictureUploadHandler());
systemWebsocket.addHandler(new EditorOriginPictureUploadOverHandler());

export default PictureTool;